import { useLocation } from 'react-router-dom';
import { UserMenu } from './UserMenu';
import { MobileSidebarToggle } from './MobileSidebarToggle';

const TITLES: Record<string, string> = {
  '/': 'Tableau de bord',
  '/orders': 'Commandes',
  '/draft-orders': 'Brouillons de commandes',
  '/products': 'Produits',
  '/inventory': 'Inventaire',
  '/customers': 'Clients',
  '/returns': 'Retours',
  '/reviews': 'Avis clients',
  '/promotions': 'Promotions',
  '/settings': 'Paramètres',
  '/settings/overview': 'Boutique',
  '/settings/tax': 'TVA',
  '/settings/shipping': 'Livraison',
  '/settings/locations': 'Emplacements de stock',
  '/settings/return-reasons': 'Motifs de retour',
  '/settings/account': 'Mon compte',
};

/**
 * Derive a contextual title for detail routes that aren't in the TITLES map.
 * List pages get their title from TITLES; detail pages (/orders/:id, etc.)
 * fall back to a human label so the sticky top bar is never blank.
 */
const detailTitleFor = (pathname: string): string => {
  if (pathname.startsWith('/orders/')) return 'Commande';
  if (pathname.startsWith('/draft-orders/')) return 'Brouillon de commande';
  if (pathname.startsWith('/customers/')) return 'Client';
  if (pathname.startsWith('/products/')) return 'Produit';
  if (pathname.startsWith('/categories/')) return 'Catégorie';
  if (pathname.startsWith('/promotions/')) return 'Promotion';
  if (pathname.startsWith('/returns/')) return 'Retour';
  if (pathname.startsWith('/settings/')) return 'Paramètres';
  return '';
};

export const Header = ({ onMenuClick }: { onMenuClick: () => void }) => {
  const location = useLocation();
  const title =
    TITLES[location.pathname] ??
    (location.pathname.startsWith('/products/') ? 'Produit' : detailTitleFor(location.pathname));

  return (
    <header className="sticky top-0 z-20 flex h-14 items-center justify-between gap-2 border-b border-border-base bg-surface-base/95 px-3.5 backdrop-blur shadow-sm supports-[backdrop-filter]:bg-surface-base/75 sm:px-6">
      <div className="flex min-w-0 items-center gap-2 sm:gap-3">
        <MobileSidebarToggle onClick={onMenuClick} />
        <div className="min-w-0 text-sm text-fg-subtle" aria-hidden={!title}>
          {title && (
            <h1 className="truncate font-serif text-base font-semibold text-fg-base sm:text-lg">
              {title}
            </h1>
          )}
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        <UserMenu />
      </div>
    </header>
  );
};
